<script>
  import { Router, Route } from 'svelte-navigator';
  import Login from './views/Login.svelte';
  import Main from './views/Main.svelte';
</script>

<Router>
  <main>
    <Route path="login">
      <Login />
    </Route>

    <Route path="*mainRoute" component={Main} />
  </main>
</Router>

<style global lang="postcss">
  @tailwind base;
  @tailwind components;
  @tailwind utilities;
</style>
